<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: 'dark' | 'light'
    width?: number | string
    title?: string
  }>(),
  {
    variant: 'dark',
    width: 151,
    title: 'Greenbow',
  },
)
</script>

<template>
  <svg
    class="greenbow-logo"
    :class="`greenbow-logo--${variant}`"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    viewBox="0 0 365.1 96.6"
    role="img"
    :aria-label="title"
  >
    <title>{{ title }}</title>
    <defs>
      <clipPath id="greenbow-logo-clip">
        <rect fill="none" width="365.1" height="62" />
      </clipPath>
    </defs>
    <g clip-path="url(#greenbow-logo-clip)">
      <path
        fill="currentColor"
        d="M315.6,21.2l5.7,28.7,6.8-28.7h13l6.8,28.5,5.6-28.5h11.6l-10.9,40.1h-13.6l-6.3-26-6.5,26h-13.5l-10.9-40.1h12.3ZM272.8,23.2c-3.2,1.7-5.7,4.1-7.5,7.2-1.8,3.1-2.7,6.8-2.7,10.9s.9,7.8,2.7,10.9c1.8,3.1,4.3,5.5,7.4,7.2,3.1,1.7,6.7,2.5,10.6,2.5s7.5-.8,10.7-2.5c3.2-1.7,5.7-4.1,7.5-7.2,1.8-3.1,2.8-6.8,2.8-10.9s-.9-7.8-2.7-10.9c-1.8-3.1-4.3-5.5-7.5-7.2-3.2-1.7-6.7-2.5-10.6-2.5s-7.5.8-10.6,2.5M289.3,33.9c1.6,1.7,2.4,4.2,2.4,7.4s-.8,5.7-2.5,7.4c-1.7,1.7-3.7,2.6-6,2.6s-4.3-.9-5.9-2.6c-1.6-1.7-2.3-4.2-2.3-7.4s.8-5.7,2.4-7.4c1.6-1.7,3.6-2.6,6-2.6s4.3.9,5.9,2.6M219.5,8.1v53.2h12.3v-5.6c1.2,1.9,2.8,3.4,5,4.5,2.1,1.1,4.6,1.7,7.4,1.7s6.3-.8,9-2.6c2.7-1.7,4.8-4.1,6.4-7.3,1.6-3.1,2.3-6.8,2.3-10.9s-.8-7.7-2.3-10.9c-1.6-3.1-3.7-5.5-6.4-7.2s-5.7-2.5-9-2.5-5.2.6-7.4,1.7c-2.2,1.2-3.8,2.7-5,4.5V8.1h-12.3ZM246.8,34c1.7,1.7,2.6,4.2,2.6,7.2s-.9,5.5-2.6,7.3c-1.7,1.8-3.8,2.7-6.3,2.7s-4.5-.9-6.2-2.7c-1.7-1.8-2.6-4.2-2.6-7.3s.9-5.5,2.6-7.3c1.7-1.8,3.8-2.7,6.2-2.7s4.6.9,6.3,2.6M191.7,22.3c-2.1,1-3.8,2.4-5,4.2v-5.3h-12.3v40.1h12.3v-21.8c0-2.7.7-4.8,2.1-6.3,1.4-1.5,3.3-2.2,5.6-2.2s4.2.7,5.6,2.2c1.4,1.5,2.1,3.6,2.1,6.3v21.8h12.2v-23.4c0-5.3-1.4-9.5-4.2-12.5-2.8-3-6.6-4.6-11.3-4.6s-5,.5-7.1,1.5M140.6,23.2c-3.1,1.7-5.5,4.1-7.2,7.2-1.7,3.1-2.6,6.8-2.6,10.9s.9,7.8,2.6,10.9c1.7,3.1,4.1,5.5,7.2,7.2,3.1,1.7,6.6,2.5,10.5,2.5s6.2-.6,8.8-1.8c2.6-1.2,4.8-2.9,6.6-5,1.7-2.1,3-4.5,3.6-7.1h-13.1c-1.2,2.6-3.3,3.9-6.4,3.9s-3.8-.7-5.2-2c-1.4-1.3-2.2-3.2-2.4-5.7h27.8c.1-1.2.2-2.4.2-3.6,0-4-.9-7.5-2.6-10.6-1.7-3-4.1-5.3-7.1-7-3-1.6-6.5-2.4-10.4-2.4s-7.5.8-10.6,2.5M156.4,32.4c1.4,1.2,2.2,2.9,2.2,5h-15.4c.3-2.2,1.2-3.9,2.6-5.1,1.4-1.2,3.2-1.8,5.2-1.8s4,.6,5.4,1.9M99.6,23.2c-3.1,1.7-5.5,4.1-7.2,7.2-1.7,3.1-2.6,6.8-2.6,10.9s.9,7.8,2.6,10.9c1.7,3.1,4.1,5.5,7.2,7.2,3.1,1.7,6.6,2.5,10.5,2.5s6.2-.6,8.8-1.8c2.6-1.2,4.8-2.9,6.6-5,1.8-2.1,3-4.5,3.6-7.1h-13.1c-1.2,2.6-3.3,3.9-6.4,3.9s-3.8-.7-5.2-2c-1.4-1.3-2.2-3.2-2.4-5.7h27.8c.1-1.2.2-2.4.2-3.6,0-4-.9-7.5-2.6-10.6-1.7-3-4.1-5.3-7.1-7-3-1.6-6.5-2.4-10.4-2.4s-7.5.8-10.6,2.5M115.5,32.4c1.4,1.2,2.2,2.9,2.2,5h-15.4c.3-2.2,1.2-3.9,2.6-5.1,1.4-1.2,3.2-1.8,5.2-1.8s4,.6,5.4,1.9M82.6,22.7c-2.2,1.3-4,3-5.4,5.2v-6.7h-12.3v40.1h12.3v-18.6c0-3.3.8-5.6,2.3-6.9,1.5-1.3,3.8-2,6.9-2h3.4v-13c-2.6,0-5,.6-7.2,1.9M.2,27.1C0,28.4,0,29.8,0,31.2,0,37.2,1.3,42.5,3.9,47.2c2.6,4.7,6.3,8.3,11,10.9,4.7,2.6,10.1,3.9,16.1,3.9s9.6-1,13.7-2.9c4-2,7.4-4.5,10-7.7,2.6-3.2,4.5-6.6,5.6-10.3v-13.8H28v10.9h18.8c-1.2,3.5-3,6.1-5.5,8-2.5,1.8-5.6,2.8-9.2,2.8-5.3,0-9.5-1.6-12.5-4.7-3-3.1-4.5-7.5-4.5-13.1s.1-2.8.3-4H.2Z"
      />
      <path
        fill="#3ba348"
        d="M1.8,19.7h4.1C12.9-.6,44.2-2.4,54.2,16.2c.6,1.1,1.2,2.3,1.6,3.5h4.1C51.4-6.6,10.3-6.5,1.8,19.7"
      />
      <path
        fill="#7cb442"
        d="M54.2,16.2C44.2-2.4,12.9-.6,5.8,19.7h4.1C16.3,3.2,42.4,2,50.6,17.4c.4.7.8,1.5,1.1,2.3h4.1c-.5-1.2-1-2.4-1.6-3.5"
      />
      <path
        fill="#a4c87b"
        d="M50.6,17.4C42.4,2,16.3,3.2,9.9,19.7h4.1c5.9-12.8,26.6-13.2,33.2-.9.2.3.3.6.5.9h4.1c-.3-.8-.7-1.5-1.1-2.3"
      />
      <path
        fill="#c1d994"
        d="M47.2,18.8c-6.6-12.3-27.3-11.9-33.2.9h4.1c5.2-8.6,20.3-8.6,25.5,0h4.1c-.1-.3-.3-.6-.5-.9"
      />
    </g>
    <g>
      <path fill="currentColor" d="M174.3,84.3v-1.7h8.5v1.7h-8.5Z" />
      <path
        fill="currentColor"
        d="M192.7,90.1c-1.1,0-2-.2-2.8-.7-.8-.5-1.5-1.1-1.9-2-.5-.8-.7-1.8-.7-3s.2-2.2.7-3.1,1.1-1.5,1.9-2c.8-.5,1.7-.7,2.8-.7s2.1.3,2.8.8,1.4,1.2,1.7,2.2c.4.9.5,2.1.5,3.4h-2.1v-.8c0-1.3-.3-2.2-.7-2.8s-1.2-.9-2.1-.9-1.8.3-2.4,1c-.5.7-.8,1.6-.8,2.9s.3,2.1.8,2.8c.5.7,1.3,1,2.3,1s1.2-.1,1.7-.4c.5-.3.9-.7,1.1-1.3l2.1.7c-.4,1-1.1,1.7-1.9,2.3-.9.5-1.8.8-2.9.8ZM188.8,85v-1.6h7.8v1.6h-7.8Z"
      />
      <path
        fill="currentColor"
        d="M198.7,89.8v-10.9h1.9v3.1h.3v7.7h-2.1ZM206.4,89.8v-5.4c0-.4,0-.9-.1-1.3,0-.4-.2-.9-.4-1.2-.2-.4-.5-.7-.8-.9-.4-.2-.8-.4-1.4-.4s-.7,0-1.1.2c-.3.1-.6.3-.9.6-.3.3-.5.6-.6,1.1-.1.5-.2,1-.2,1.6l-1.3-.5c0-1,.2-1.9.6-2.6.4-.8.9-1.3,1.6-1.8.7-.4,1.5-.6,2.5-.6s1.4.1,1.9.4.9.6,1.2,1c.3.4.6.8.7,1.3.2.5.3.9.3,1.4,0,.4,0,.8,0,1.2v6h-2.1Z"
      />
      <path
        fill="currentColor"
        d="M217.9,90.1c-1,0-1.9-.3-2.6-.8s-1.3-1.2-1.7-2.1c-.4-.9-.6-1.9-.6-2.9s.2-2.1.6-2.9c.4-.9,1-1.5,1.7-2,.7-.5,1.6-.8,2.6-.8s1.9.3,2.6.8,1.2,1.2,1.6,2.1c.4.9.5,1.8.5,2.9s-.2,2.1-.5,2.9c-.4.9-.9,1.6-1.6,2.1-.7.5-1.6.8-2.6.8ZM218.2,88.2c.7,0,1.3-.2,1.7-.5.4-.3.8-.8,1-1.4s.3-1.2.3-2-.1-1.4-.3-2c-.2-.6-.5-1-.9-1.4-.4-.3-1-.5-1.6-.5s-1.3.2-1.7.5c-.5.3-.8.8-1,1.4-.2.6-.3,1.2-.3,1.9s.1,1.4.3,1.9c.2.6.5,1,1,1.4.4.3,1,.5,1.7.5ZM221.1,89.8v-7.8h-.2v-6.7h2.1v14.5h-1.9Z"
      />
      <path
        fill="currentColor"
        d="M229.9,90.1c-1.1,0-2-.2-2.8-.7-.8-.5-1.5-1.1-1.9-2-.5-.8-.7-1.8-.7-3s.2-2.2.7-3.1,1.1-1.5,1.9-2c.8-.5,1.7-.7,2.8-.7s2.1.3,2.8.8,1.4,1.2,1.7,2.2c.4.9.5,2.1.5,3.4h-2.1v-.8c0-1.3-.3-2.2-.7-2.8s-1.2-.9-2.1-.9-1.8.3-2.4,1c-.5.7-.8,1.6-.8,2.9s.3,2.1.8,2.8c.5.7,1.3,1,2.3,1s1.2-.1,1.7-.4c.5-.3.9-.7,1.1-1.3l2.1.7c-.4,1-1.1,1.7-1.9,2.3-.9.5-1.8.8-2.9.8ZM226,85v-1.6h7.8v1.6h-7.8Z"
      />
      <path fill="currentColor" d="M236.4,89.8v-14.8h2.1v14.8h-2.1Z" />
      <path
        fill="currentColor"
        d="M247.1,90.1c-.8,0-1.5-.1-2-.4-.5-.3-1-.7-1.2-1.2-.3-.5-.4-1-.4-1.6s0-1,.3-1.5c.2-.4.5-.8.9-1.1s.9-.5,1.4-.7c.5-.1,1-.3,1.6-.4.6-.1,1.3-.2,1.9-.3.7,0,1.3-.2,2-.3l-.8.4c0-.9-.2-1.5-.5-1.9s-1-.6-1.9-.6-1.1.1-1.6.4-.8.7-1,1.3l-2-.6c.3-.9.8-1.7,1.5-2.2s1.8-.8,3-.8,1.8.2,2.5.5c.7.3,1.3.9,1.6,1.6.2.4.3.7.3,1.1s0,.8,0,1.3v6.7h-1.9v-2.5l.4.3c-.5.8-1,1.5-1.7,1.9-.7.4-1.6.6-2.6.6ZM247.4,88.4c.6,0,1.1-.1,1.5-.3.4-.2.8-.5,1-.8.3-.3.4-.7.5-1,.1-.3.2-.7.2-1.1s0-.7,0-1l.7.3c-.7.1-1.3.2-1.8.3-.5,0-1,.2-1.5.2-.4,0-.8.2-1.2.3-.3.1-.5.2-.8.4s-.4.3-.5.5c-.1.2-.2.4-.2.7s0,.5.2.8.4.4.6.6.7.2,1.1.2Z"
      />
      <path
        fill="currentColor"
        d="M253.9,80.6v-1.7h6.7v1.7h-6.7ZM255.7,89.8v-11.3c0-.3,0-.6,0-.9,0-.3,0-.6.2-.9,0-.3.3-.6.5-.8.3-.3.6-.5.9-.6s.7-.2,1-.2c.3,0,.6,0,.9,0h1.4v1.7h-1.3c-.5,0-.9.1-1.1.4s-.4.6-.4,1v11.7h-2.1Z"
      />
      <path
        fill="currentColor"
        d="M267.3,90.1c-1.1,0-2-.3-2.7-.8-.7-.6-1.2-1.3-1.5-2.3l2.1-.5c0,.4.3.8.7,1.2.4.3.8.5,1.3.5s.6,0,1-.2c.3-.2.6-.4.8-.8.1-.2.2-.5.2-.8,0-.3,0-.7,0-1.1v-9.9h2.1v9.9c0,.4,0,.8,0,1.1,0,.3,0,.7-.1.9,0,.3-.2.6-.4.9-.4.7-.9,1.2-1.5,1.5-.6.3-1.3.5-2.1.5Z"
      />
      <path
        fill="currentColor"
        d="M275.1,94.6l2.1-5.7v1.7s-4.7-11.7-4.7-11.7h2.2l3.5,9h-.6l3.4-9h2.1l-6,15.7h-2Z"
      />
      <path
        fill="currentColor"
        d="M288,90.1c-1.3,0-2.4-.3-3.2-.9-.8-.6-1.3-1.4-1.5-2.5l2.2-.3c.1.6.4,1,.9,1.3.5.3,1.1.5,1.8.5s1.2-.1,1.5-.4.6-.6.6-1.1,0-.5-.2-.7c-.1-.2-.4-.3-.8-.5-.4-.2-1.1-.3-1.9-.6-.9-.2-1.7-.5-2.2-.8s-.9-.6-1.2-1-.3-.8-.3-1.4.2-1.2.5-1.7c.3-.5.8-.9,1.5-1.1.6-.3,1.4-.4,2.2-.4s1.6.1,2.2.4c.7.3,1.2.6,1.6,1.1.4.5.6,1,.7,1.7l-2.2.4c0-.5-.3-.9-.7-1.2-.4-.3-1-.5-1.6-.5-.6,0-1.2,0-1.6.3-.4.2-.6.6-.6,1s0,.4.2.6c.2.2.4.3.9.5.4.2,1.1.3,1.9.6.9.2,1.6.5,2.2.8.5.3.9.6,1.2,1,.2.4.3.9.3,1.4,0,1.1-.4,1.9-1.2,2.5-.8.6-1.9.9-3.2.9Z"
      />
      <path
        fill="currentColor"
        d="M293.8,89.8v-14.5h2.1v8.9l4.3-5.2h2.7l-4.5,5.4,5,5.4h-2.9l-4.6-5.2v5.2h-2.1Z"
      />
      <path fill="currentColor" d="M306.8,89.8v-14.5h9.3v2h-7.2v4.1h6v2h-6v4.5h7.2v2h-9.3Z" />
      <path
        fill="currentColor"
        d="M317.7,89.8v-10.9h1.9v3.1h.3v7.7h-2.1ZM325.3,89.8v-5.4c0-.4,0-.9-.1-1.3,0-.4-.2-.9-.4-1.2-.2-.4-.5-.7-.8-.9-.4-.2-.8-.4-1.4-.4s-.7,0-1.1.2c-.3.1-.6.3-.9.6-.3.3-.5.6-.6,1.1-.1.5-.2,1-.2,1.6l-1.3-.5c0-1,.2-1.9.6-2.6.4-.8.9-1.3,1.6-1.8.7-.4,1.5-.6,2.5-.6s1.4.1,1.9.4.9.6,1.2,1c.3.4.6.8.7,1.3.2.5.3.9.3,1.4,0,.4,0,.8,0,1.2v6h-2.1Z"
      />
      <path
        fill="currentColor"
        d="M334,90.1c-1.1,0-2-.2-2.8-.7-.8-.5-1.5-1.1-1.9-2-.5-.8-.7-1.8-.7-3s.2-2.2.7-3.1,1.1-1.5,1.9-2c.8-.5,1.7-.7,2.8-.7s2.1.3,2.8.8,1.4,1.2,1.7,2.2c.4.9.5,2.1.5,3.4h-2.1v-.8c0-1.3-.3-2.2-.7-2.8s-1.2-.9-2.1-.9-1.8.3-2.4,1c-.5.7-.8,1.6-.8,2.9s.3,2.1.8,2.8c.5.7,1.3,1,2.3,1s1.2-.1,1.7-.4c.5-.3.9-.7,1.1-1.3l2.1.7c-.4,1-1.1,1.7-1.9,2.3-.9.5-1.8.8-2.9.8ZM330.1,85v-1.6h7.8v1.6h-7.8Z"
      />
      <path
        fill="currentColor"
        d="M340.4,89.8v-10.9h1.9v2.6l-.3-.3c.1-.3.3-.7.5-1s.5-.5.7-.7c.3-.2.6-.4.9-.5.3-.1.7-.2,1-.2.4,0,.7,0,1,0v2c-.4,0-.8-.1-1.2,0-.4,0-.8.2-1.2.4-.3.2-.6.5-.8.8-.2.3-.3.7-.4,1.1,0,.4-.1.8-.1,1.2v5.5h-2.1Z"
      />
      <path
        fill="currentColor"
        d="M351.3,90.1c-1,0-1.9-.3-2.6-.8s-1.3-1.2-1.7-2.1c-.4-.9-.6-1.9-.6-2.9s.2-2.1.6-2.9c.4-.9,1-1.5,1.7-2,.7-.5,1.6-.8,2.6-.8s1.9.3,2.6.8,1.2,1.2,1.6,2.1c.4.9.5,1.8.5,2.9s-.2,2.1-.5,2.9c-.4.9-.9,1.6-1.6,2.1-.7.5-1.6.8-2.6.8ZM351.4,94.9c-.6,0-1.2,0-1.7-.3-.5-.2-1-.4-1.5-.8-.5-.4-.8-.8-1.1-1.3l1.9-1c.2.5.6.8,1,1,.4.2.9.3,1.4.3s1.1-.1,1.5-.3c.4-.2.7-.5,1-1,.2-.4.3-.9.3-1.6v-3h.3v-8.1h1.9v11.2c0,.3,0,.6,0,.8,0,.3,0,.5-.1.8-.2.7-.4,1.3-.9,1.8-.4.5-1,.8-1.7,1.1-.7.2-1.4.4-2.3.4ZM351.6,88.2c.7,0,1.3-.2,1.7-.5.4-.3.8-.8,1-1.4s.3-1.2.3-2-.1-1.4-.3-2c-.2-.6-.5-1-.9-1.4-.4-.3-1-.5-1.6-.5s-1.3.2-1.7.5c-.5.3-.8.8-1,1.4-.2.6-.3,1.2-.3,1.9s.1,1.4.3,1.9c.2.6.5,1,1,1.4.4.3,1,.5,1.7.5Z"
      />
      <path fill="currentColor" d="M358.6,77.1v-2h2.1v2h-2.1ZM358.6,89.8v-10.9h2.1v10.9h-2.1Z" />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.greenbow-logo {
  display: block;
  height: auto;

  &--dark {
    color: #12133d;
  }

  &--light {
    color: #fff;
  }
}
</style>
